import { useEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import styles from "../styles/AboutPage.module.css";
import backgroundImage from "../assets/our-view-in-the-sea.jpg";

gsap.registerPlugin(ScrollTrigger);

export default function AboutPage() {
  const pageRef = useRef(null);
  const subtitleRef = useRef(null);
  const titleRef = useRef(null);
  const contentRef = useRef(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      // Subtitle + title entrance
      const introTl = gsap.timeline({
        scrollTrigger: {
          trigger: pageRef.current,
          start: "top 85%",
        },
        defaults: { ease: "power3.out" },
      });

      introTl
        .from(subtitleRef.current, { y: 20, opacity: 0, duration: 0.6 })
        .from(titleRef.current, { y: 30, opacity: 0, duration: 0.8 }, "-=0.3");

      // Card itself rises into place
      gsap.from(contentRef.current, {
        y: 60,
        opacity: 0,
        duration: 0.9,
        ease: "power3.out",
        scrollTrigger: {
          trigger: contentRef.current,
          start: "top 90%",
        },
      });

      // Each paragraph fades/slides in individually as it's scrolled to
      gsap.utils.toArray(`.${styles.content} p`).forEach((p) => {
        gsap.from(p, {
          y: 24,
          opacity: 0,
          duration: 0.7,
          ease: "power2.out",
          scrollTrigger: {
            trigger: p,
            start: "top 92%",
          },
        });
      });
    }, pageRef);

    return () => ctx.revert();
  }, []);

  return (
    <section
      ref={pageRef}
      className={styles.page}
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <div className={styles.container}>
        <span ref={subtitleRef} className={styles.subtitle}>
          Our Story
        </span>

        <h1 ref={titleRef} className={styles.title}>
          The Story Behind Fegaropetra
        </h1>

        <div ref={contentRef} className={styles.content}>
          <p>
            Fegaropetra is a family business located in the bay of Garitsa,
            offering magnificent views of the sea and the Old Fortress.
          </p>

          <p>
            The restaurant combines elegant white aesthetics with the natural
            beauty of the surrounding trees, creating a warm and welcoming
            atmosphere for every guest.
          </p>

          <p>
            The open kitchen fills the space with delicious aromas while the
            owner and chef personally oversees every dish, ensuring quality and
            attention to detail.
          </p>

          <p>
            At <span className={styles.highlight}>Fegaropetra</span>, fresh
            Greek ingredients and traditional recipes take center stage,
            allowing the authentic flavors of seafood and Mediterranean cuisine
            to shine.
          </p>
        </div>
      </div>
    </section>
  );
}